import React from "react";
import { ComponentListPageInitialState, PageNewState } from "./";

export const ComponentListPageContext = React.createContext({
  pageState: ComponentListPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
